import axios from "axios";
import React, { useEffect, useState } from "react";
import { Empresa } from "../../../Models/Cadastros/Empresa/Empresa";
import { useSnackbar } from "notistack";
import PopupBasePage from "../../../Components/Base/BasePopup";
import TabHeaderComponent from "../../../Components/Navigations/SimpleTabHeaderComponent";
import TabPanelComponent from "../../../Components/Navigations/SimpleTabPanelComponent";
import EmpresaDadosTab from "./EmpresaDadosTab";

const EmpresaCadastroPopup = (props: any) => {
    const [tabValue, setTabValue] = React.useState(0);
    const [empresa, setEmpresa] = useState<any>(new Empresa());
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        (async () => {
            if ((props.empresa?.id ?? 0) != 0) {
                setEmpresa(props.empresa);
            }
        })();
    }, []);
    
    async function save() {
        try {
            let responseId: any = null;
            if (empresa?.id == null ||empresa?.id == 0 || empresa?.id == '') {
                let response = await axios.post('empresas', empresa);
                responseId = response.data.id;
            }
            else {
                let response = await axios.put(`empresas/${empresa.id}`, empresa);
                responseId = response.data.id;
            }

            enqueueSnackbar('Salvo com sucesso!', {variant: 'success'});
            let response: any = await axios.get(`empresas/${responseId}`);
            setEmpresa(response.data);
        } catch (error) {
            enqueueSnackbar('Erro ao salvar!', {variant: 'error'});
        }
        finally {
            document.body.style.cursor = "default";
        }
    }
    
    return (
        <PopupBasePage title="Empresa" isOpen={props.isOpen} onClose={props.onClose} onClickFirstButtonPopupCallback={save} isPesquisa='false' confirmClose={true}>
            <div className="container">
                <div className="row">
                    <div className="align-all-left col-md-12 order-md-1">
                        <TabHeaderComponent setTabValueEventCallBack={setTabValue} label="Cadastro Empresa" tabs={['Dados', 'Histórico']} tab="empresa" />

                        <form className="needs-validation" id="formEmpresaDados">
                            <TabPanelComponent value={tabValue} index={0} tab="empresa" tabHeader="empresa">
                                <EmpresaDadosTab empresa={empresa} />
                            </TabPanelComponent>
                        </form>

                        <TabPanelComponent value={tabValue} index={1} tab="empresa" tabHeader="empresa">
                            {/* <EmpresaFiltroAcessosTab empresa={empresa} /> */}
                        </TabPanelComponent>
                    </div>
                </div>
            </div >
        </PopupBasePage >
    );
}

export default EmpresaCadastroPopup;